import HeroShift from "./HeroShift";
import { useMarketingLang } from "../i18n.jsx";

export default function Hero() {
  const { t } = useMarketingLang();
  return (
    <section
      id="top"
      className="relative pt-16 md:pt-20 pb-12 md:pb-20 overflow-hidden"
      style={{
        background:
          "radial-gradient(1100px 600px at 18% -10%, rgba(77,212,232,0.10), transparent 60%), radial-gradient(900px 500px at 90% 10%, rgba(240,178,58,0.06), transparent 60%)",
      }}
    >
      <div className="container-page">
        <p className="eyebrow mb-6">{t('hero.eyebrow')}</p>

        <h1 className="h-display max-w-[900px] text-ink">
          {t('hero.titlePre')}
          <span className="text-amber">{t('hero.titleHighlight')}</span>.
        </h1>

        <p className="body-lead mt-6">
          {t('hero.lead')}
        </p>

        <div className="mt-9 flex flex-wrap items-center gap-3">
          <a
            href="#book"
            className="group inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-teal text-bg-base text-[15px] font-medium hover:brightness-110 transition-all"
          >
            {t('hero.bookDemo')}
            <span className="inline-block transition-transform group-hover:translate-x-[3px]">
              →
            </span>
          </a>
          <a
            href="#try"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border-hairline-base border-hairline-hover text-[15px] text-ink/85 hover:text-ink transition-all"
          >
            {t('hero.tryLive')}
          </a>
        </div>
      </div>

      <div className="container-page mt-14 md:mt-20">
        <HeroShift />
      </div>
    </section>
  );
}
